import React from 'react';
import { Link } from 'react-router-dom'; // Import Link for navigation
import styles from './LandingPage.module.css';
// Assuming React Bits components will be imported here as needed
// import { SomeAnimatedComponent } from 'react-bits';

const LandingPage: React.FC = () => {
  return (
    <div className={styles.landingPage}>
      <header className={styles.header}>
        <nav className={styles.nav}>
          <Link to="/login" className={styles.loginLink}>Login</Link>
        </nav>
      </header>
      <section className={styles.heroSection}>
        <h1>Stop Chasing Invoices. Start Getting Paid.</h1>
        <p>Automate professional payment reminders and boost your cash flow by 25-40%, saving you hours every week.</p>
        <button className={styles.primaryCta}>Get Started Free</button>
        {/* Placeholder for engaging illustration/image, potentially using React Bits for animation */}
      </section>

      <section className={styles.problemSolutionSection}>
        <h2>Tired of the Payment Chase?</h2>
        <p>Manual follow-ups are time-consuming, awkward, and hurt your cash flow. Focus on your business, not your overdue invoices.</p>
        <h2>Introducing Invoice Chaser.</h2>
        <p>Your automated partner for effortless payment collection. Professional reminders, stronger client relationships, and faster payments.</p>
      </section>

      <section className={styles.featuresSection}>
        <h2>Features Designed for Small Business Owners</h2>
        <div className={styles.featureGrid}>
          <div className={styles.featureCard}>
            <h3>Seamless QuickBooks Integration</h3>
            <p>Automatically import all your invoice data. No manual entry needed.</p>
          </div>
          <div className={styles.featureCard}>
            <h3>Automated Email Reminders</h3>
            <p>Set it and forget it. Professional, personalized emails sent on your schedule.</p>
          </div>
          <div className={styles.featureCard}>
            <h3>Direct Payment Links</h3>
            <p>Make it easy for clients to pay instantly with secure payment links.</p>
          </div>
          <div className={styles.featureCard}>
            <h3>Clear Dashboard Overview</h3>
            <p>See all your overdue invoices at a glance. Know exactly who owes what.</p>
          </div>
          <div className={styles.featureCard}>
            <h3>Flexible Manual Control</h3>
            <p>Pause automation or send one-off reminders whenever you need to.</p>
          </div>
        </div>
      </section>

      <section className={styles.howItWorksSection}>
        <h2>How It Works in 3 Simple Steps</h2>
        <div className={styles.stepsGrid}>
          <div className={styles.stepCard}>
            <h3>1. Connect</h3>
            <p>Securely link your QuickBooks and email in minutes.</p>
          </div>
          <div className={styles.stepCard}>
            <h3>2. Automate</h3>
            <p>Set your reminder schedule and let Invoice Chaser do the work.</p>
          </div>
          <div className={styles.stepCard}>
            <h3>3. Get Paid</h3>
            <p>Watch your cash flow improve as invoices get paid faster.</p>
          </div>
        </div>
      </section>

      <section className={styles.ctaSection}>
        <h2>Ready to Get Paid Faster?</h2>
        <button className={styles.primaryCta}>Start Your Free Trial Today</button>
      </section>

      <footer className={styles.footer}>
        <p>&copy; {new Date().getFullYear()} Invoice Chaser. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default LandingPage;
